const toFiniteOrder = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const getExplicitTankOrder = (tank) => {
  const properties = tank?.properties || {};

  return (
    toFiniteOrder(tank?.displayOrder) ??
    toFiniteOrder(tank?.sortOrder) ??
    toFiniteOrder(tank?.sequence) ??
    toFiniteOrder(tank?.order) ??
    toFiniteOrder(properties.displayOrder) ??
    toFiniteOrder(properties.sortOrder) ??
    toFiniteOrder(properties.sequence) ??
    toFiniteOrder(properties.order) ??
    null
  );
};

const normalizeTankName = (value) => String(value || "").trim();

const getTankNameParts = (tankName) => {
  const normalizedName = normalizeTankName(tankName).toUpperCase();
  const numberMatch = normalizedName.match(/\d+/);
  const number = numberMatch ? parseInt(numberMatch[0], 10) : null;
  const sideMatch = normalizedName.match(/(PORT|STARBOARD|STBD|P|S)$/);
  const side = sideMatch?.[1] || "";

  return {
    normalizedName,
    number,
    side,
  };
};

export const compareCargoTanks = (left, right) => {
  const leftOrder = getExplicitTankOrder(left);
  const rightOrder = getExplicitTankOrder(right);

  if (leftOrder != null || rightOrder != null) {
    if (leftOrder == null) return 1;
    if (rightOrder == null) return -1;
    if (leftOrder !== rightOrder) return leftOrder - rightOrder;
  }

  const leftParts = getTankNameParts(left?.name);
  const rightParts = getTankNameParts(right?.name);

  if (leftParts.number != null && rightParts.number != null) {
    if (leftParts.number !== rightParts.number) {
      return leftParts.number - rightParts.number;
    }

    if (
      (leftParts.side === "P" || leftParts.side === "PORT") &&
      (rightParts.side === "S" ||
        rightParts.side === "STBD" ||
        rightParts.side === "STARBOARD")
    ) {
      return -1;
    }

    if (
      (leftParts.side === "S" ||
        leftParts.side === "STBD" ||
        leftParts.side === "STARBOARD") &&
      (rightParts.side === "P" || rightParts.side === "PORT")
    ) {
      return 1;
    }
  }

  return leftParts.normalizedName.localeCompare(rightParts.normalizedName, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

const mapCanonicalTank = (tank) => ({
  id: tank.id,
  name: normalizeTankName(tank.name),
  tankType: tank.tankType,
  active: tank.active !== false,
  capacity: tank.capacity,
  coating: tank.coating,
  properties: tank.properties || {},
});

const mapFallbackTank = ([tankName, details]) => ({
  id: details?.tankId || normalizeTankName(tankName).toLowerCase(),
  name: normalizeTankName(tankName),
  tankType: "cargo",
  active: details?.active !== false,
  capacity: details?.capacity ?? details?.cube,
  coating: details?.coating,
  properties: details || {},
});

export const getCargoTanksForActiveVessel = (shipData) => {
  const canonicalTanks = Array.isArray(shipData?.tanks)
    ? shipData.tanks
        .map(mapCanonicalTank)
        .filter((tank) => tank.name && tank.tankType === "cargo" && tank.active)
    : [];

  if (canonicalTanks.length > 0) {
    return canonicalTanks.sort(compareCargoTanks);
  }

  const fallbackCargoTanks = Object.entries(
    shipData?.configuration?.tankLayout?.cargoTanks || {}
  )
    .map(mapFallbackTank)
    .filter((tank) => tank.name && tank.active);

  return fallbackCargoTanks.sort(compareCargoTanks);
};

